import { formatGymPrice } from '../../utils/gymMoney';

export const paymentMethods = [
  { key: 'cash', label: 'Cash' },
  { key: 'card', label: 'Card' },
  { key: 'bank_transfer', label: 'Bank Transfer' },
  { key: 'qr', label: 'QR Payment' },
];

export const packageOptions = ['Basic', 'Standard', 'Premium'];

export const lockerSizeOptions = ['Small', 'Medium', 'Large'];

export const equipmentCategoryOptions = ['Cardio', 'Strength', 'Functional', 'Other'];

export const equipmentStatusOptions = [
  { value: 'available', label: 'Available' },
  { value: 'in-use', label: 'In Use' },
  { value: 'maintenance', label: 'Maintenance' },
];

export function formatCurrency(amount) {
  return formatGymPrice(amount);
}
